import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {
  Alert,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  Badge,
  UncontrolledTooltip,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  FormGroup
} from "reactstrap"
import TableContainer from "../../components/Common/TableContainer";

//Import Breadcrumb
import Breadcrumbs from "/src/components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
// Modals
import GroupDestinationModal from "./GroupDestinationModal"
// Language
import i18n from "../../i18n";
// Form
import * as Yup from 'yup';
import { useFormik } from "formik";
import Spinners from "../../components/Common/Spinner"

const GroupDestinationRouting = () => {
  document.title = "Admin Web Routing";

  const dispatch = useDispatch();

  useEffect(() => {

  }, [dispatch]);

  const [groupDestinationRoutingModal, setGroupDestinationRoutingModal] = useState(false);
  const toggleViewModal = () => setGroupDestinationRoutingModal(!groupDestinationRoutingModal);
  const [showModalDestination, setShowModalDestination] = useState(false);
  const [selectedRoutingDestination, setSelectedRoutingDestination] = useState({});

  const [isLoading, setLoading] = useState(true)

  const [drp_link, setDrp_link] = useState(false);

  const autoformik = useFormik({
    initialValues: {
      search: "",
      startPoint: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      startPoint: Yup.string()
    })
  });

  const handleOrderClicks = () => {
    setOrder("");
    setIsEdit(false);
    toggle();
  };

  const handleOrderClick = (arg) => {
    const order = arg;
    setOrder({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderDate: order.orderDate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeClass: order.badgeClass,
    });

    setIsEdit(true);

    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: 'No',
        accessorKey: 'id',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: i18n.t("Company"),
        accessorKey: 'company',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: i18n.t("ServiceNumber"),
        accessorKey: 'serviceNumber',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: i18n.t("StartingPoint"),
        accessorKey: 'startingPoint',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Destination"),
        accessorKey: 'destination',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Passengers"),
        accessorKey: 'passengers',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Scales"),
        accessorKey: 'numberScales',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Date"),
        accessorKey: 'date',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Hour"),
        accessorKey: 'hour',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Type"),
        accessorKey: 'type',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
            return (
                cellProps.row.original.type == "A Disposición" ? 
                  <span className="bg-success badge bg-secondary">{cellProps.row.original.type}</span> :
                  <span className="bg-danger badge bg-secondary">{cellProps.row.original.type}</span>
            )
        }
      },
      {
        header: 'Action',
        accessorKey: 'action',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="showtooltip" />
                  <UncontrolledTooltip placement="top" target="showtooltip">
                    {i18n.t("Show")}
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  className="btn btn-sm btn-soft-info">
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    {i18n.t("Edit")}
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  className="btn btn-sm btn-soft-danger">
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    {i18n.t("Delete")}
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        }
      }
    ],
    [handleOrderClick, toggleViewModal]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs title={i18n.t("GroupDestination")} breadcrumbItem={i18n.t("Routing")} />
        <Card>
          <CardBody className="pb-2">
            <Row className="pb-2">
              <Col xs={12} xl={12} md={6} className="pb-2">
                <Row>
                  <Col xxl={9} md={7} xs={12}>
                    <CardTitle className="h4">{i18n.t("GroupDestination")}</CardTitle>
                  </Col>
                  <Col xxl={3} md={5} xs={12} className="text-end">
                    <Row>
                      <Col xxl={8} md={8} xs={12}>
                        <GroupDestinationModal setGroupDestinationRoutingModal={setGroupDestinationRoutingModal} listModifyRouting={[]} isOpen={groupDestinationRoutingModal} toggle={toggleViewModal} setSelectedRoutingDestination={setSelectedRoutingDestination} setShowModalDestination={setShowModalDestination} />
                        <button onClick={toggleViewModal} className="btn btn-danger">{i18n.t("GroupDestination")}</button>
                      </Col>
                      <Col xxl={2} md={2} xs={12}>
                        <button className="btn btn-light">o</button>
                      </Col>
                      <Col xxl={2} md={2} xs={12}>
                        <ButtonDropdown isOpen={drp_link} toggle={() => { setDrp_link(!drp_link) }}>
                          <DropdownToggle className="btn btn-success px-3" caret color="secondary">
                            l
                          </DropdownToggle>
                          <DropdownMenu>
                              <DropdownItem>{i18n.t("Routing")}</DropdownItem>
                              <DropdownItem>{i18n.t("Routing")}</DropdownItem>
                          </DropdownMenu>
                        </ButtonDropdown>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} xl={12} md={6} className="pb-2">
                <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
                  <Col xxl={4} md={4} xs={12}>
                    <div className="col-sm-auto">                        
                      <Input type="text" name="search" className="form-control" id="searchInput" placeholder={i18n.t("SearchCompany")}
                        value={autoformik.values.search}
                        onChange={autoformik.handleChange}
                        onBlur={autoformik.handleBlur}
                        invalid={
                          autoformik.touched.search && autoformik.errors.search ? true : false
                        } />
                      {
                        autoformik.errors.search && autoformik.touched.search ? (
                          <FormFeedback type="invalid">{autoformik.errors.search}</FormFeedback>
                        ) : null
                      }
                    </div>
                  </Col>
                  <Col xxl={3} md={3} xs={12}>
                    <div className="col-sm-auto">
                      <Input type="text" name="startPoint" className="form-control" id="startPointInput" placeholder={i18n.t("StartPoint")}
                        value={autoformik.values.startPoint}
                        onChange={autoformik.handleChange}
                        onBlur={autoformik.handleBlur}
                        invalid={
                          autoformik.touched.startPoint && autoformik.errors.startPoint ? true : false
                        } />
                      {
                        autoformik.errors.startPoint && autoformik.touched.startPoint ? (
                          <FormFeedback type="invalid">{autoformik.errors.startPoint}</FormFeedback>
                        ) : null
                      }
                    </div>
                  </Col>
                </Form>
                <div className="table-responsive pt-3">
                  {
                    isLoading ? <Spinners setLoading={setLoading} /> :
                    <Col>
                      <TableContainer
                        columns={columns}
                        data={[]}
                        isGlobalFilter={false}
                        isAddButton={false}
                        isCustomPageSize={false}
                        handleUserClick={handleOrderClicks}
                        isPagination={true}
                        SearchPlaceholder="26 records..."
                        buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                        buttonName=""
                        tableClass="table table-bordered mb-0"
                        theadClass=""
                        pagination="pagination"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      />
                    </Col>
                  }
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <div className="">
          <div id="liveAlertPlaceholder">
            <Alert className="custom-alert" isOpen={showModalDestination} toggle={() => {
              setShowModalDestination(false)
            }}>
              <h5>
                <i className="fa fa-check mx-2"></i>
                {i18n.t("GroupedDestinationServices")}
              </h5>
              {i18n.t("SuccessGroupDestinationServices", {id: selectedRoutingDestination.id, countItem: selectedRoutingDestination.countItem})}
            </Alert>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

GroupDestinationRouting.propTypes = {
  onGetEmployees: PropTypes.func
}

export default GroupDestinationRouting;